export const llmModels = [
  {key: "gpt-3.5-turbo", name: "GPT 3.5 Turbo"},
  {key: "gpt-4-turbo", name: "GPT 4 Turbo"},
  {key: "gpt-4o", name: "GPT 4o"},
  {key: "gpt-4o-mini", name: "GPT 4o mini"},
];

export const reasonedLlmModels = [
  {key: "gpt-o1", name: "GPT o1"},
  {key: "gpt-o3-mini", name: "GPT o3 mini"},
];
